import request from '../../../utils/Request';
import { Methods } from '../../../config';

const baseURL = 'szikaMetro/jobMonitor';

const SzMJobMonitorService = {
  getProductionOperationsFromView: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productionOperations/view`,
      data,
    });
  },
};

export default SzMJobMonitorService;
